module.exports = __webpack_public_path__ + "static/media/galeria-fotos-3-big.92363a97.jpeg";